var render = function (_h,_vm) {var _c=_vm._c;return (_vm.props.infos.length > 0)?_c('div',_vm._g(_vm._b({ref:_vm.data.ref,class:[
    'infos px-3 py-1 text-xs text-white bg-orange-500',
    _vm.data.class,
    _vm.data.staticClass ],style:([_vm.data.style, _vm.data.staticStyle])},'div',_vm.data.attrs,false),_vm.listeners),[_c('span',{staticClass:"block text-center error"},[_vm._v(_vm._s(_vm.props.infos[0]))])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }